import { render, staticRenderFns } from "./fotos.vue?vue&type=template&id=0132ec0a&"
import script from "./fotos.vue?vue&type=script&lang=js&"
export * from "./fotos.vue?vue&type=script&lang=js&"
import style0 from "./fotos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports